/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {

    var ticking = false;
    var last_known_scroll_position;


    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade'});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});

    myApp.initCatalogoDownload();

  }

  // El PDF del catálogo suele pesar varias decenas de MB: en vez de
  // abrirlo en el modal (lento/poco confiable), el botón lo abre
  // directo en una pestaña nueva usando el visor nativo del navegador.
  myApp.initCatalogoDownload = function() {

    var pdfUrl = $('#mdl_catalogo .embed-responsive-item').attr('src');

    if (!pdfUrl) {
      return;
    }

    $('[data-target="#mdl_catalogo"]').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    });

  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
